import calc from '../../calc/index.js';
import parserData from '../_parserdata.js';
import escapeRegExp from '../_escaperegexp.js';
var hiddenPropertyPrefix = ("" + Math.random()).replace('0.', 'hidden');
var hiddenPropertyIndex = 0;
export default function defineHiddenContentProperty(_ref) {
  var object = _ref.object,
    keys = _ref.keys,
    text = _ref.text;
  var key = "" + hiddenPropertyPrefix + hiddenPropertyIndex;
  var regs = {};
  var escLeftBracket = parserData.escLeftBracket,
    escRightBracket = parserData.escRightBracket;
  hiddenPropertyIndex += 1;
  // create and cache regular expressions which will help us to
  // change target property value quickly when sources are changed
  // TODO: We need better parser!
  for (var i = 0; i < keys.length; i++) {
    regs[keys[i]] = new RegExp(escLeftBracket + "\\s*" + escapeRegExp(keys[i]) + "\\s*" + escRightBracket, 'g');
  }
  calc(object, key, keys, function () {
    var result = text;
    // replace things like {{x}} by actual values; a function keeps "$&" and the like in a value literal
    for (var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++) {
      values[_key] = arguments[_key];
    }
    var _loop = function _loop() {
      var value = values[_i] === null || values[_i] === undefined ? '' : String(values[_i]);
      result = result.replace(regs[keys[_i]], function () {
        return value;
      });
    };
    for (var _i = 0; _i < keys.length; _i++) {
      _loop();
    }
    return result;
  }, {
    isTargetPropertyHidden: true,
    debounceCalc: false
  });
  return key;
}